export default  [
    {
        path: 'opcao-chamada',
        redirect: 'opcao-chamada/index',
        component: () => import(
            /* webpackChunkName: 'painel-senha-opcao-chamada' */
            '@/views/painel-senha/opcao-chamada/Index'
        ),
        children: [
            {
                name: 'painel-senha-opcao-chamada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-chamada' */
                    '@/views/painel-senha/opcao-chamada/List'
                ),
            },
            {
                name: 'painel-senha-opcao-chamada-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-chamada' */
                    '@/views/painel-senha/opcao-chamada/Form.vue'
                ),
            },
            {
                name: 'painel-senha-opcao-chamada-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'painel-senha-opcao-chamada' */
                    '@/views/painel-senha/opcao-chamada/Form.vue'
                ),
            },
        ],
    },
]